import {DataStatus, TabProps, Tabs} from 'platform/components';

import {ORDER_TABS} from '@dms/shared';

import {Nullish, RequiredTestIdProps} from 'shared/web';

interface OrderCardTabsProps extends RequiredTestIdProps {
  tabs: TabProps[];
  activeTabId: string | Nullish;
  onChange: (id: string) => void;
  isLoading: boolean;
  isError: boolean;
}

export function OrderCardTabs(props: OrderCardTabsProps) {
  return (
    <Tabs
      // Same tab bar as "condensed", but the tab panel has no bottom padding, so only the
      // Card body padding (16px) stays under the tab content.
      variant="fullHeight"
      onChange={props.onChange}
      activeTabId={props.activeTabId}
      tabs={props.tabs.map((tab) => ({
        ...tab,
        // These sections fetch their own content and keep edits disabled until order state arrives.
        content:
          tab.id === ORDER_TABS.JOBS || tab.id === ORDER_TABS.ALL_ITEMS ? (
            tab.content
          ) : (
            <DataStatus isLoading={props.isLoading} isError={props.isError} minHeight={56}>
              {tab.content}
            </DataStatus>
          ),
      }))}
      data-testid={props['data-testid']}
      isLazy
      shouldWrap
      lazyBehavior="unmount"
    />
  );
}
